import { render, staticRenderFns } from "./LogDetailDrawer.vue?vue&type=template&id=c5487e36&scoped=true"
import script from "./LogDetailDrawer.vue?vue&type=script&lang=js"
export * from "./LogDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./LogDetailDrawer.vue?vue&type=style&index=0&id=c5487e36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5487e36",
  null
  
)

export default component.exports